import { Autocomplete, Chip, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../redux/types'

interface IBrand {
  id: number
  name: string
}

export function UserBrand2Autocomplete({ user, userSelected, handleInputChange }: any) {
  const { t } = useTranslation(['global'])

  const { userBrands } = useSelector((state: IRootState) => state.brand)
  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { errorForm, msgForm } = useSelector((state: IRootState) => state.validator)

  const handleMultiAutoCompleteChange = (brands: IBrand[]) => {
    let optionsMulti: number[] = []
    if (brands !== null) {
      for (let i = 0; i < brands.length; i++) {
        optionsMulti.push(brands[i].id)
      }
    }

    handleInputChange('brands', optionsMulti)
  }

  return (
    <Autocomplete
      id="combo-box-brands2"
      ChipProps={{ color: 'secondary' }}
      value={userBrands.filter((brand: any) => user.brands.includes(brand.id))}
      onChange={(_, value) => handleMultiAutoCompleteChange(value)}
      options={userBrands}
      multiple
      disabled={[3, 4, 6, 8, 9].includes(authUser.role_id) && authUser.id === user.id}
      getOptionLabel={(option: any) => (option.id !== undefined ? option.name : '')}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            label={option.name}
            {...getTagProps({ index })}
            disabled={
              userSelected !== null && user.id !== 0
                ? userSelected.permissions.notEditBrands.includes(option.id) ||
                  ([3, 4, 6].includes(authUser.role_id) && authUser.id === user.id)
                : false
            }
          />
        ))
      }
      renderInput={params => (
        <TextField
          {...params}
          label={t('brands')}
          variant="filled"
          InputLabelProps={{ shrink: true }}
          error={errorForm.brands}
          helperText={msgForm.brands}
        />
      )}
    />
  )
}
